module.exports = __webpack_public_path__ + "static/img/login_left.a0a81e03.png";